type ApiResponseLike = {
  ok: boolean
  status?: number
  data?: unknown
}

export type PasswordResetRequestOutcome =
  | { kind: 'requested' }
  | {
      kind: 'failed'
      reasonCode: 'server_error' | 'throttled' | 'network'
      status?: number
    }

export type PasswordResetConfirmOutcome =
  | { kind: 'completed' }
  | {
      kind: 'failed'
      reasonCode: 'token_invalid' | 'validation' | 'non_field' | 'unknown'
      status?: number
      fieldErrors?: string[]
      generalError?: string
    }

export const classifyPasswordResetRequest = (
  response: ApiResponseLike,
): PasswordResetRequestOutcome => {
  if (response.ok) {
    return { kind: 'requested' }
  }
  if (response.status && response.status >= 500) {
    return {
      kind: 'failed',
      reasonCode: 'server_error',
      status: response.status,
    }
  }
  if (response.status === 429) {
    return { kind: 'failed', reasonCode: 'throttled', status: 429 }
  }
  if (!response.status) {
    return { kind: 'failed', reasonCode: 'network' }
  }
  // Other 4xx responses are treated as requested so analytics cannot
  // distinguish whether the email exists.
  return { kind: 'requested' }
}

export const classifyPasswordResetConfirm = (
  response: ApiResponseLike,
): PasswordResetConfirmOutcome => {
  if (response.ok) {
    return { kind: 'completed' }
  }

  const data = response.data as Record<string, unknown> | undefined
  if (response.status === 400 && data) {
    if (data.detail) {
      return { kind: 'failed', reasonCode: 'token_invalid', status: 400 }
    }
    if (Array.isArray(data.new_password)) {
      return {
        kind: 'failed',
        reasonCode: 'validation',
        status: 400,
        fieldErrors: data.new_password as string[],
      }
    }
    if (Array.isArray(data.non_field_errors)) {
      return {
        kind: 'failed',
        reasonCode: 'non_field',
        status: 400,
        generalError: (data.non_field_errors as string[]).join(' '),
      }
    }
  }

  return {
    kind: 'failed',
    reasonCode: 'unknown',
    status: response.status,
  }
}
